import UnstarDocumentsModal from './UnstarDocumentsModal.component';

export default UnstarDocumentsModal;